export const COURSE_STATUS = {
  GRANT: {
    id: '019a837b-ac34-7ec0-b838-9a5a67bbd413',
    label: 'Deferido (Dispensa)'
  },
  NOT_GRANT: {
    id: '019a837b-dac1-7907-a536-29d961f7c7ed',
    label: 'Indeferido'
  },
  ADAPTATION: {
    id: '019a837b-fd42-71c0-bc2d-dabbeb7be54c',
    label: 'Adaptação'
  }
}
